import React from 'react'
import './index.scss'
import clsx from 'clsx'
import CircledIcon from '@Components/CircledIcon'
import { IconType } from '@Const/common'

export interface HeadingDecorationProps {
    icon: IconType
    title: string
    toolTip?: React.ReactNode
    required?: boolean
    rowLength: number
    useAlternateHeader?: boolean
    rightData?: React.ReactNode
}

const HeadingDecoration = ({
    icon,
    title,
    toolTip,
    required,
    rowLength,
    useAlternateHeader,
    rightData,
}: HeadingDecorationProps) => (
    <div className={clsx('table-heading-decoration', useAlternateHeader && 'alternate')}>
        {!useAlternateHeader && <CircledIcon icon={icon} />}
        <span>{title}</span>
        <span>({rowLength})</span>
        {toolTip && <span>{toolTip}</span>}
        <span className="required">
            {useAlternateHeader ? (required ? '(REQUIRED)' : '(OPTIONAL)') : required ? 'REQUIRED' : 'OPTIONAL'}
        </span>
        <span className="right-data">{rightData}</span>
    </div>
)

export default HeadingDecoration
